import { useState } from 'react';
import createUseContext from 'constate';

const useECSettings = () => {
  const [ecSettings, setECSettings] = useState(null);
  return {
    ecSettings,
    setECSettings,
  };
};

const [ECSettingsProvider, useECSettingsContext] = createUseContext(useECSettings);

export {
  ECSettingsProvider,
  useECSettingsContext,
};
